export type Language = "en" | "zh" | "de" | "pt";

export interface Translations {
  [key: string]: {
    [key: string]: string;
  };
}

export const translations: Translations = {
  en: {
    // Header
    "nav.home": "Home",
    "nav.about": "About Us",
    "nav.terms": "Terms & Conditions",
    "nav.privacy": "Privacy",

    // Homepage
    "home.title": "Powerful Image Convertor Online",
    "home.subtitle":
      "Are you looking for a useful and free tool to convert image formats, such as JPG to PNG, WEBP to JPG?",
    "home.subtitle2":
      "Congratulations, you found it! This is the website you were looking for.",
    "home.tools.description":
      "We provide convenient, fast and comprehensive tools",
    "home.platform.description":
      "Use our all-in-one platform to improve efficiency and achieve smarter image format conversion processing.",
    "home.simplify.tasks": "Simplify your basic tasks",
    "home.conversion.steps":
      "You only need a few simple steps to freely convert images into high-quality formats.",
    "home.resize.title": "Resize Images",
    "home.convert.title": "Convert Formats",
    "home.compress.title": "Compress Images",
    "home.resize.now": "Resize Now",
    "home.compress.now": "Compress Now",

    // Common
    "common.upload": "Upload",
    "common.convert": "Convert",
    "common.download": "Download",
    "common.or": "or",
    "common.drag": "drag",
    "common.file": "file",
    "common.to": "to",
    "common.this": "this",
    "common.area": "area",
    "common.toUpload": "to upload",
    "common.convertNow": "Convert Now",
    "common.close": "Close",
    "common.dimensions": "Dimensions: ",
    "common.file.size": "File size: ",
    "common.image.load.failed": "Image failed to load",

    // Resize Page
    "resize.upload.title": "Upload Your Image",
    "resize.original.dimensions": "Original dimensions: ",
    "resize.supported.formats": "Supported formats: ",
    "resize.format.original": "Original Format",
    "resize.status.processing": "Resizing your image...",
    "resize.status.complete": "Resize complete! Preparing download...",
    "resize.download.button": "Resize & Download",
    "resize.options.title": "Resize Options",
    "resize.width.label": "Width (px)",
    "resize.height.label": "Height (px)",
    "resize.width.required": "Please enter width",
    "resize.height.required": "Please enter height",
    "resize.percentage.required": "Please enter percentage",
    "resize.aspect.ratio": "Maintain Aspect Ratio",
    "resize.output.format": "Output Format",
    "resize.success.title": "Resize Successful!",
    "resize.method.label": "Resize Method",
    "resize.scale.percentage": "Scale Percentage",
    "resize.percentage.message": "Please enter percentage",
    "resize.original.image": "Original Image",
    "resize.resized.image": "Resized Image",
    "resize.estimated.size": "Estimated file size: {size} KB",
    "resize.download.resized": "Download Resized Image",
    "resize.success.message": "Your image has been successfully resized.",
    "resize.download.hint":
      "Click the Download button to save the resized image to your device.",
    "resize.preview.hint": "You can also view the result in the preview area.",

    // Compress Page
    "compress.upload.title": "Upload Your Image",
    "compress.upload.description":
      "Upload your image and click Compress to reduce file size while maintaining visual quality.",
    "compress.tool.description":
      "This tool compresses {format} images using advanced algorithms",
    "compress.upload.complete": "Upload Complete: {filename}",
    "compress.original.size": "Original size: {size}",
    "compress.technology.description":
      "{description} using high-performance compression technology.",
    "compress.upload.hint":
      "Click or drag {format} file to this area to upload",
    "compress.upload.format.hint":
      "Only {format} files are accepted for compression.",
    "compress.status": "Compressing your image...",
    "compress.download.button": "Compress & Download",
    "compress.back.home": "Back to Home",
    "compress.complete": "Compression Complete",
    "compress.compressed.size": "Compressed size: {size}",
    "compress.reduction": "Reduction: {percentage}%",
    "compress.download.again": "Download",
    "compress.comparison.title": "Before and After Comparison",
    "compress.comparison.original": "Original",
    "compress.comparison.compressed": "Compressed",

    // Detail Page
    "detail.upload.required": "Please upload an image first!",
    "detail.convert.success": "Successfully converted to {format}",
    "detail.convert.error": "Failed to convert image. Please try again.",
    "detail.upload.description":
      "Please upload a {fromFormat} file and click the Convert button. The converted {toFormat} file will be automatically downloaded.",
    "detail.step1.title": "1. Upload Your {format} Image",
    "detail.upload.complete": "Upload Complete: {filename}",
    "detail.upload.change":
      "Click here to upload a different file or proceed to conversion",
    "detail.upload.hint": "Click or drag {format} file to this area to upload",
    "detail.upload.format.hint":
      "Only {format} files are accepted for this conversion.",
    "detail.step2.title": "2. Convert and Download",
    "detail.convert.button": "Convert & Download",
    "detail.conversion.complete":
      "✓ Conversion complete! Your file has been automatically downloaded.",
    "detail.upload.status": "Upload Complete",
    "detail.upload.success": "has been uploaded successfully.",
    "detail.upload.proceed":
      "You can now proceed to convert your {fromFormat} file to {toFormat}.",

    // Footer
    "footer.support.email": "Customer support Email: picmodifier@outlook.com",

    // Resize
    "resize.exact.name": "Exact Dimensions",
    "resize.exact.description": "Resize to specific width and height",
    "resize.width.name": "By Width",
    "resize.width.description":
      "Resize to specific width, maintaining aspect ratio",
    "resize.height.name": "By Height",
    "resize.height.description":
      "Resize to specific height, maintaining aspect ratio",
    "resize.percentage.name": "By Percentage",
    "resize.percentage.description": "Scale image by percentage",
    "resize.format.jpg.name": "JPG Resize",
    "resize.format.jpg.description":
      "Resize JPG images to your preferred dimensions while maintaining quality. Perfect for web use or sharing.",
    "resize.format.jpeg.name": "JPEG Resize",
    "resize.format.jpeg.description":
      "Adjust JPEG dimensions to fit your requirements. Ideal for web pages, documents, and presentations.",
    "resize.format.png.name": "PNG Resize",
    "resize.format.png.description":
      "Resize PNG images with transparency. Perfect for logos, icons, and graphics that need size adjustment.",

    // Compress
    "compress.jpg.name": "JPG Compress",
    "compress.jpg.description":
      "Optimize JPG images for faster web loading and reduced storage. Perfect for photographs and complex images.",
    "compress.jpeg.name": "JPEG Compress",
    "compress.jpeg.description":
      "Reduce JPEG file size for email attachments and web sharing. Maintains good visual quality at smaller sizes.",
    "compress.png.name": "PNG Compress",
    "compress.png.description":
      "Reduce PNG file size while maintaining quality and transparency for logos, icons, and graphics.",

    // Convert
    "convert.webp.jpeg":
      "Convert WebP to JPEG for better compatibility with older browsers and applications",
    "convert.webp.jpg":
      "Convert WebP to JPG for better compatibility with all devices and applications",
    "convert.webp.png":
      "Convert WebP to PNG for lossless image quality with transparency support",
    "convert.webp.ico":
      "Convert WebP to ICO for website favicons and application icons",
    "convert.webp.bmp":
      "Convert WebP to BMP for compatibility with older Windows applications",
    "convert.webp.apng":
      "Convert WebP to APNG for animated images with transparency support",

    "convert.jpeg.webp":
      "Convert JPEG to WebP for smaller file sizes and better web performance",
    "convert.jpeg.jpg":
      "Convert JPEG to JPG (same format, different extension)",
    "convert.jpeg.png":
      "Convert JPEG to PNG for better quality and transparency support",
    "convert.jpeg.ico": "Convert JPEG to ICO for favicon and application icons",
    "convert.jpeg.bmp":
      "Convert JPEG to BMP for use with older Windows applications",
    "convert.jpeg.apng": "Convert JPEG to APNG for basic animation support",

    "convert.jpg.webp":
      "Convert JPG to WebP for smaller file sizes and better web performance",
    "convert.jpg.jpeg":
      "Convert JPG to JPEG (same format, different extension)",
    "convert.jpg.png":
      "Convert JPG to PNG for better quality and transparency support",
    "convert.jpg.ico": "Convert JPG to ICO for favicon and application icons",
    "convert.jpg.bmp":
      "Convert JPG to BMP for use with older Windows applications",
    "convert.jpg.apng": "Convert JPG to APNG for basic animation support",

    "convert.png.webp":
      "Convert PNG to WebP for smaller file sizes while preserving transparency",
    "convert.png.jpeg":
      "Convert PNG to JPEG for smaller file sizes (note: transparency will be lost)",
    "convert.png.jpg":
      "Convert PNG to JPG for smaller file sizes and wider compatibility",
    "convert.png.ico":
      "Convert PNG to ICO for website favicon and application icons",
    "convert.png.bmp":
      "Convert PNG to BMP for compatibility with older Windows applications",
    "convert.png.apng": "Convert PNG to APNG for adding animation capabilities",

    "convert.ico.webp":
      "Convert ICO to WebP for modern web usage with better compression",
    "convert.ico.jpeg":
      "Convert ICO to JPEG for better compatibility with photo editors",
    "convert.ico.jpg":
      "Convert ICO to JPG for better compatibility with all devices and applications",
    "convert.ico.png":
      "Convert ICO to PNG for better quality and modern format",
    "convert.ico.bmp":
      "Convert ICO to BMP for compatibility with older Windows applications",
    "convert.ico.apng": "Convert ICO to APNG for adding animation to icons",

    "convert.bmp.webp":
      "Convert BMP to WebP for much smaller file sizes and better web performance",
    "convert.bmp.jpeg":
      "Convert BMP to JPEG for smaller file sizes and better compatibility",
    "convert.bmp.jpg":
      "Convert BMP to JPG for smaller file sizes and wider compatibility",
    "convert.bmp.png":
      "Convert BMP to PNG for lossless compression and transparency support",
    "convert.bmp.ico":
      "Convert BMP to ICO for use as favicons and application icons",
    "convert.bmp.apng": "Convert BMP to APNG for adding animation capabilities",

    "convert.apng.webp":
      "Convert APNG to WebP for better compression while preserving animation",
    "convert.apng.jpeg":
      "Convert APNG to JPEG (note: animation and transparency will be lost)",
    "convert.apng.jpg":
      "Convert APNG to JPG (note: animation and transparency will be lost)",
    "convert.apng.png":
      "Convert APNG to PNG (note: animation will be lost but transparency preserved)",
    "convert.apng.ico":
      "Convert APNG to ICO for use as favicons (animation will be lost)",
    "convert.apng.bmp":
      "Convert APNG to BMP (animation and transparency will be lost)",

    // About Page
    "about.title": "About Us",
    "about.welcome":
      "Welcome to Image Converter, your go-to tool for all image conversion needs. We've built this platform to provide a simple yet powerful solution for converting images between various formats.",
    "about.mission.title": "Our Mission",
    "about.mission.content":
      "Our mission is to make image conversion accessible to everyone. Whether you're a professional designer, developer, or just someone who needs to convert an image occasionally, we've got you covered. We strive to provide a user-friendly service that delivers high-quality image conversions without the need for specialized software or technical knowledge.",
    "about.why.title": "Why Choose Us?",
    "about.fast.title": "Fast Conversion",
    "about.fast.content":
      "Our conversion engine is optimized for speed, allowing you to convert your images in seconds.",
    "about.privacy.title": "Privacy First",
    "about.privacy.content":
      "Your privacy is important to us. All image processing happens in your browser, and we don't store your images on our servers.",
    "about.noinstall.title": "No Installation Required",
    "about.noinstall.content":
      "Access our tool from any device with a web browser. No need to install additional software.",
    "about.userfriendly.title": "User-Friendly",
    "about.userfriendly.content":
      "We've designed our interface to be intuitive and easy to use for everyone, regardless of technical expertise.",
    "about.team.title": "Our Team",
    "about.team.content":
      "We are a small team of passionate developers and designers who believe in creating tools that make people's lives easier. Our diverse backgrounds in web development, UI/UX design, and image processing have enabled us to create a tool that combines technical excellence with ease of use.",
    "about.team.lead": "Lead Developer",
    "about.team.designer": "UI/UX Designer",
    "about.team.expert": "Image Processing Expert",
    "about.philosophy.title": "Our Philosophy",
    "about.philosophy.content1":
      "We simplify image processing and conversion online, providing a quick and easy solution. Our platform was created to eliminate the need for downloading software, which is a common hassle for most users dealing with images.",
    "about.philosophy.content2":
      "We have integrated all the essential functionalities required for processing images, whether for personal or business use, into one convenient location.",
    "about.philosophy.content3":
      "Why do we offer these image editing tools for free? We believe in democratizing access to high-quality image editing tools. Everyone deserves a cost-free solution without compromising on quality.",

    // Privacy Page
    "privacy.title": "Privacy Policy",
    "privacy.intro":
      "At Image Converter, picmodifier.com value your privacy and are committed to protecting your personal information. This Privacy Policy explains how picmodifier.com handle your data when you use picmodifier.com service. picmodifier.com want to emphasize that picmodifier.com do not collect or store any personal customer information.",
    "privacy.info.title": "1. Information picmodifier.com Handle",
    "privacy.info.image.title": "1.1 Image Data:",
    "privacy.info.image.content":
      "When you use picmodifier.com image conversion service, your images are processed entirely in your browser. picmodifier.com do not store your images on picmodifier.com servers, and they are automatically deleted after processing.",
    "privacy.info.personal.title": "1.2 No Personal Information Collection:",
    "privacy.info.personal.content":
      "picmodifier.com do not collect any personal information from picmodifier.com users. You can use picmodifier.com service without providing any personal details.",
    "privacy.info.usage.title": "1.3 Anonymous Usage Data:",
    "privacy.info.usage.content":
      "picmodifier.com only collect anonymous usage data such as browser type, referring/exit pages, and date/time stamps. This information is used solely to improve picmodifier.com service and user experience. No personal identifiers are collected or stored.",
    "privacy.info.cookies.title": "1.4 Cookies:",
    "privacy.info.cookies.content":
      "picmodifier.com use minimal cookies to enhance your experience on picmodifier.com site. These cookies do not track personal information. You can set your browser to refuse all or some browser cookies, but this may affect functionality.",
    "privacy.use.title": "2. How picmodifier.com Use Information",
    "privacy.use.service.title": "2.1 Service Provision:",
    "privacy.use.service.content":
      "picmodifier.com use the information solely to provide and maintain picmodifier.com service, including performing image conversions as requested. All processing is done locally in your browser.",
    "privacy.use.improve.title": "2.2 Service Improvement:",
    "privacy.use.improve.content":
      "picmodifier.com analyze anonymous usage patterns to improve picmodifier.com website, products, and services. This analysis does not involve any personal information.",
    "privacy.use.communications.title": "2.3 Communications:",
    "privacy.use.communications.content":
      "If you choose to contact picmodifier.com, picmodifier.com will only use your provided contact information to respond to your specific inquiry. picmodifier.com do not store this information for marketing purposes.",
    "privacy.security.title": "3. Data Security",
    "privacy.security.content":
      "picmodifier.com implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure. While picmodifier.com strive to use commercially acceptable means to protect your data, picmodifier.com cannot guarantee its absolute security.",
    "privacy.thirdparty.title": "4. Third-Party Services",
    "privacy.thirdparty.content":
      "picmodifier.com service may contain links to third-party websites or services that are not owned or controlled by picmodifier.com. picmodifier.com have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.",
    "privacy.children.title": "5. Children's Privacy",
    "privacy.children.content":
      "picmodifier.com service is not intended for use by children under the age of 13. picmodifier.com do not knowingly collect personally identifiable information from children under 13. If you are a parent or guardian and believe your child has provided picmodifier.com with personal information, please contact picmodifier.com immediately.",
    "privacy.changes.title": "6. Changes to This Privacy Policy",
    "privacy.changes.content":
      "picmodifier.com may update picmodifier.com Privacy Policy from time to time. picmodifier.com will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.",
    "privacy.contact.title": "7. Contact picmodifier.com",
    "privacy.contact.content":
      "If you have any questions about this Privacy Policy, please contact picmodifier.com at picmodifier@outlook.com.",
    "privacy.last.updated": "Last updated: {date}",

    // Terms Page
    "terms.title": "Terms of Service",
    "terms.welcome":
      "Welcome to picmodifier.com. By accessing or using picmodifier.com service, you agree to be bound by these Terms of Service. Please read these terms carefully before using picmodifier.com service.",
    "terms.acceptance.title": "1. Acceptance of Terms",
    "terms.acceptance.content":
      "By accessing or using picmodifier.com service, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing picmodifier.com service.",
    "terms.license.title": "2. Use License",
    "terms.license.permission.title": "2.1 Permission:",
    "terms.license.permission.content":
      "picmodifier.com grant you a limited, non-exclusive, non-transferable license to use picmodifier.com service for personal, non-commercial purposes.",
    "terms.license.restrictions.title": "2.2 Restrictions:",
    "terms.license.restrictions.content": "You may not:",
    "terms.license.restrictions.list":
      '• Modify or copy the materials\n• Use the materials for any commercial purpose\n• Attempt to decompile or reverse engineer any software contained in picmodifier.com service\n• Remove any copyright or other proprietary notations from the materials\n• Transfer the materials to another person or "mirror" the materials on any other server',
    "terms.content.title": "3. User Content",
    "terms.content.ownership.title": "3.1 Ownership:",
    "terms.content.ownership.content":
      "You retain all rights to your content. By using picmodifier.com service, you grant picmodifier.com a limited license to process your content solely for the purpose of providing the service.",
    "terms.content.prohibited.title": "3.2 Prohibited Content:",
    "terms.content.prohibited.content":
      "You agree not to upload, process, or share any content that:",
    "terms.content.prohibited.list":
      "• Violates any laws or regulations\n• Infringes on intellectual property rights\n• Contains harmful or malicious code\n• Is inappropriate, offensive, or violates any third-party rights",
    "terms.disclaimer.title": "4. Disclaimer",
    "terms.disclaimer.content":
      'picmodifier.com service is provided "as is." picmodifier.com make no warranties, expressed or implied, and hereby disclaim and negate all other warranties, including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.',
    "terms.limitations.title": "5. Limitations",
    "terms.limitations.content":
      "In no event shall picmodifier.com or picmodifier.com suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use picmodifier.com service.",
    "terms.accuracy.title": "6. Accuracy of Materials",
    "terms.accuracy.content":
      "The materials appearing on picmodifier.com service could include technical, typographical, or photographic errors. picmodifier.com do not warrant that any of the materials on picmodifier.com service are accurate, complete, or current. picmodifier.com may make changes to the materials contained on picmodifier.com service at any time without notice.",
    "terms.links.title": "7. Links",
    "terms.links.content":
      "picmodifier.com have not reviewed all of the sites linked to picmodifier.com service and are not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by picmodifier.com of the site. Use of any such linked website is at the user's own risk.",
    "terms.modifications.title": "8. Modifications",
    "terms.modifications.content":
      "picmodifier.com may revise these terms of service at any time without notice. By using picmodifier.com service, you are agreeing to be bound by the then current version of these terms of service.",
    "terms.governing.title": "9. Governing Law",
    "terms.governing.content":
      "These terms and conditions are governed by and construed in accordance with the laws and you irrevocably submit to the exclusive jurisdiction of the courts in that location.",
    "terms.contact.title": "10. Contact picmodifier.com",
    "terms.contact.content":
      "If you have any questions about these Terms of Service, please contact picmodifier.com at picmodifier@outlook.com.",
    "terms.last.updated": "Last updated: {date}",
  },
  zh: {
    // Header
    "nav.home": "首页",
    "nav.about": "关于我们",
    "nav.terms": "条款和条件",
    "nav.privacy": "隐私政策",

    // Homepage
    "home.title": "强大的在线图片转换工具",
    "home.subtitle":
      "您是否在寻找一个实用且免费的工具来转换图片格式，比如 JPG 转 PNG，WEBP 转 JPG？",
    "home.subtitle2": "恭喜您，您找到了！这就是您一直在寻找的网站。",
    "home.tools.description": "我们提供便捷、快速和全面的工具",
    "home.platform.description":
      "使用我们的一站式平台提高效率，实现更智能的图片格式转换处理。",
    "home.simplify.tasks": "简化您的基础任务",
    "home.conversion.steps":
      "您只需几个简单的步骤即可自由地将图片转换为高质量格式。",
    "home.resize.title": "调整图片大小",
    "home.convert.title": "转换格式",
    "home.compress.title": "压缩图片",
    "home.resize.now": "立即调整",
    "home.compress.now": "立即压缩",

    // Common
    "common.upload": "上传",
    "common.convert": "转换",
    "common.download": "下载",
    "common.or": "或",
    "common.drag": "拖拽",
    "common.file": "文件",
    "common.to": "到",
    "common.this": "这个",
    "common.area": "区域",
    "common.toUpload": "来上传",
    "common.convertNow": "立即转换",
    "common.close": "关闭",
    "common.dimensions": "尺寸：",
    "common.file.size": "文件大小：",
    "common.image.load.failed": "图片加载失败",

    // Resize Page
    "resize.upload.title": "上传您的图片",
    "resize.original.dimensions": "原始尺寸：",
    "resize.supported.formats": "支持的格式：",
    "resize.format.original": "原始格式",
    "resize.status.processing": "正在调整图片大小...",
    "resize.status.complete": "调整完成！准备下载...",
    "resize.download.button": "调整并下载",
    "resize.options.title": "调整选项",
    "resize.width.label": "宽度（像素）",
    "resize.height.label": "高度（像素）",
    "resize.width.required": "请输入宽度",
    "resize.height.required": "请输入高度",
    "resize.percentage.required": "请输入百分比",
    "resize.aspect.ratio": "保持宽高比",
    "resize.output.format": "输出格式",
    "resize.success.title": "调整成功！",
    "resize.method.label": "调整方式",
    "resize.scale.percentage": "缩放百分比",
    "resize.percentage.message": "请输入百分比",
    "resize.original.image": "原始图片",
    "resize.resized.image": "调整后的图片",
    "resize.estimated.size": "预计文件大小：{size} KB",
    "resize.download.resized": "下载调整后的图片",
    "resize.success.message": "您的图片已成功调整大小。",
    "resize.download.hint": "点击下载按钮将调整后的图片保存到您的设备。",
    "resize.preview.hint": "您也可以在预览区域查看结果。",

    // Compress Page
    "compress.upload.title": "上传您的图片",
    "compress.upload.description":
      "上传您的图片并点击压缩，在保持视觉质量的同时减小文件大小。",
    "compress.tool.description": "此工具使用高级算法压缩{format}图片",
    "compress.upload.complete": "上传完成：{filename}",
    "compress.original.size": "原始大小：{size}",
    "compress.technology.description": "{description}使用高性能压缩技术。",
    "compress.upload.hint": "点击或拖拽{format}文件到此区域上传",
    "compress.upload.format.hint": "仅接受{format}文件进行压缩。",
    "compress.status": "正在压缩您的图片...",
    "compress.download.button": "压缩并下载",
    "compress.back.home": "返回首页",
    "compress.complete": "压缩完成",
    "compress.compressed.size": "压缩后大小：{size}",
    "compress.reduction": "减少：{percentage}%",
    "compress.download.again": "下载",
    "compress.comparison.title": "压缩前后对比",
    "compress.comparison.original": "原图",
    "compress.comparison.compressed": "压缩后",

    // Detail Page
    "detail.upload.required": "请先上传图片！",
    "detail.convert.success": "已成功转换为{format}",
    "detail.convert.error": "图片转换失败，请重试。",
    "detail.upload.description":
      "请上传{fromFormat}文件并点击转换按钮。转换后的{toFormat}文件将自动下载。",
    "detail.step1.title": "1. 上传您的{format}图片",
    "detail.upload.complete": "上传完成：{filename}",
    "detail.upload.change": "点击此处上传其他文件或继续转换",
    "detail.upload.hint": "点击或拖拽{format}文件到此区域上传",
    "detail.upload.format.hint": "仅接受{format}文件进行此转换。",
    "detail.step2.title": "2. 转换并下载",
    "detail.convert.button": "转换并下载",
    "detail.conversion.complete": "✓ 转换完成！您的文件已自动下载。",
    "detail.upload.status": "上传完成",
    "detail.upload.success": "已成功上传。",
    "detail.upload.proceed": "您现在可以将{fromFormat}文件转换为{toFormat}。",

    // Footer
    "footer.support.email": "客户支持邮箱：picmodifier@outlook.com",

    // Resize
    "resize.exact.name": "精确尺寸",
    "resize.exact.description": "调整到特定宽度和高度",
    "resize.width.name": "按宽度",
    "resize.width.description": "调整到特定宽度，保持比例",
    "resize.height.name": "按高度",
    "resize.height.description": "调整到特定高度，保持比例",
    "resize.percentage.name": "按百分比",
    "resize.percentage.description": "按百分比缩放图像",
    "resize.format.jpg.name": "JPG调整",
    "resize.format.jpg.description":
      "调整JPG图像到您首选的尺寸，同时保持质量。非常适合网络使用或共享。",
    "resize.format.jpeg.name": "JPEG调整",
    "resize.format.jpeg.description":
      "调整JPEG尺寸以适应您的需求。非常适合网页、文档和演示文稿。",
    "resize.format.png.name": "PNG调整",
    "resize.format.png.description":
      "调整PNG图像透明度。非常适合需要调整大小的徽标、图标和图形。",

    // Compress
    "compress.jpg.name": "JPG压缩",
    "compress.jpg.description":
      "优化JPG图像以加快网络加载和减少存储。非常适合照片和复杂图像。",
    "compress.jpeg.name": "JPEG压缩",
    "compress.jpeg.description":
      "减少JPEG文件大小以用于电子邮件附件和网络共享。在较小尺寸上保持良好的视觉效果。",
    "compress.png.name": "PNG压缩",
    "compress.png.description":
      "减少PNG文件大小，同时保持质量和透明度用于徽标、图标和图形。",

    // Convert
    "convert.webp.jpeg":
      "将WebP转换为JPEG以获得更好的旧版浏览器和应用程序兼容性",
    "convert.webp.jpg": "将WebP转换为JPG以获得更好的所有设备和应用程序兼容性",
    "convert.webp.png": "将WebP转换为PNG以获得无损图像质量和透明度支持",
    "convert.webp.ico": "将WebP转换为ICO用于网站图标和应用程序图标",
    "convert.webp.bmp": "将WebP转换为BMP以获得旧版Windows应用程序兼容性",
    "convert.webp.apng": "将WebP转换为APNG以获得带透明度的动画图像",

    "convert.jpeg.webp": "将JPEG转换为WebP以获得更小的文件大小和更好的网页性能",
    "convert.jpeg.jpg": "将JPEG转换为JPG（相同格式，不同扩展名）",
    "convert.jpeg.png": "将JPEG转换为PNG以获得更好的质量和透明度支持",
    "convert.jpeg.ico": "将JPEG转换为ICO用于网站图标和应用程序图标",
    "convert.jpeg.bmp": "将JPEG转换为BMP用于旧版Windows应用程序",
    "convert.jpeg.apng": "将JPEG转换为APNG以获得基本动画支持",

    "convert.jpg.webp": "将JPG转换为WebP以获得更小的文件大小和更好的网页性能",
    "convert.jpg.jpeg": "将JPG转换为JPEG（相同格式，不同扩展名）",
    "convert.jpg.png": "将JPG转换为PNG以获得更好的质量和透明度支持",
    "convert.jpg.ico": "将JPG转换为ICO用于网站图标和应用程序图标",
    "convert.jpg.bmp": "将JPG转换为BMP用于旧版Windows应用程序",
    "convert.jpg.apng": "将JPG转换为APNG以获得基本动画支持",

    "convert.png.webp": "将PNG转换为WebP以获得更小的文件大小同时保持透明度",
    "convert.png.jpeg":
      "将PNG转换为JPEG以获得更小的文件大小（注意：将失去透明度）",
    "convert.png.jpg": "将PNG转换为JPG以获得更小的文件大小和更广泛的兼容性",
    "convert.png.ico": "将PNG转换为ICO用于网站图标和应用程序图标",
    "convert.png.bmp": "将PNG转换为BMP用于旧版Windows应用程序",
    "convert.png.apng": "将PNG转换为APNG以添加动画功能",

    "convert.ico.webp": "将ICO转换为WebP以获得更好的压缩和现代网页使用",
    "convert.ico.jpeg": "将ICO转换为JPEG以获得更好的照片编辑器兼容性",
    "convert.ico.jpg": "将ICO转换为JPG以获得更好的所有设备和应用程序兼容性",
    "convert.ico.png": "将ICO转换为PNG以获得更好的质量和现代格式",
    "convert.ico.bmp": "将ICO转换为BMP用于旧版Windows应用程序",
    "convert.ico.apng": "将ICO转换为APNG以添加图标动画",

    "convert.bmp.webp": "将BMP转换为WebP以获得更小的文件大小和更好的网页性能",
    "convert.bmp.jpeg": "将BMP转换为JPEG以获得更小的文件大小和更好的兼容性",
    "convert.bmp.jpg": "将BMP转换为JPG以获得更小的文件大小和更广泛的兼容性",
    "convert.bmp.png": "将BMP转换为PNG以获得无损压缩和透明度支持",
    "convert.bmp.ico": "将BMP转换为ICO用于网站图标和应用程序图标",
    "convert.bmp.apng": "将BMP转换为APNG以添加动画功能",

    "convert.apng.webp": "将APNG转换为WebP以获得更好的压缩同时保持动画",
    "convert.apng.jpeg": "将APNG转换为JPEG（注意：将失去动画和透明度）",
    "convert.apng.jpg": "将APNG转换为JPG（注意：将失去动画和透明度）",
    "convert.apng.png": "将APNG转换为PNG（注意：将失去动画但保持透明度）",
    "convert.apng.ico": "将APNG转换为ICO用于网站图标（将失去动画）",
    "convert.apng.bmp": "将APNG转换为BMP（将失去动画和透明度）",

    // About Page
    "about.title": "关于我们",
    "about.welcome":
      "欢迎使用图片转换工具，您的图片转换需求一站式解决方案。我们构建这个平台是为了提供一个简单而强大的解决方案，用于在各种格式之间转换图片。",
    "about.mission.title": "我们的使命",
    "about.mission.content":
      "我们的使命是让图片转换变得人人可用。无论您是专业设计师、开发人员，还是偶尔需要转换图片的普通用户，我们都能满足您的需求。我们致力于提供用户友好的服务，无需专业软件或技术知识即可实现高质量的图片转换。",
    "about.why.title": "为什么选择我们？",
    "about.fast.title": "快速转换",
    "about.fast.content":
      "我们的转换引擎经过速度优化，让您能在几秒钟内完成图片转换。",
    "about.privacy.title": "隐私优先",
    "about.privacy.content":
      "我们重视您的隐私。所有图片处理都在您的浏览器中进行，我们不会在服务器上存储您的图片。",
    "about.noinstall.title": "无需安装",
    "about.noinstall.content":
      "通过任何带有网页浏览器的设备即可访问我们的工具。无需安装额外软件。",
    "about.userfriendly.title": "用户友好",
    "about.userfriendly.content":
      "我们设计的界面直观易用，无论技术水平如何，每个人都能轻松上手。",
    "about.team.title": "我们的团队",
    "about.team.content":
      "我们是一支充满激情的开发者和设计师组成的小团队，致力于创造让生活更便捷的工具。我们在网页开发、UI/UX设计和图片处理方面的多样化背景，使我们能够创造出既技术卓越又易于使用的工具。",
    "about.team.lead": "首席开发工程师",
    "about.team.designer": "UI/UX设计师",
    "about.team.expert": "图片处理专家",
    "about.philosophy.title": "我们的理念",
    "about.philosophy.content1":
      "我们致力于简化在线图片处理和转换，提供快速便捷的解决方案。我们的平台旨在消除下载软件的需求，这是大多数用户处理图片时经常遇到的麻烦。",
    "about.philosophy.content2":
      "我们将处理图片所需的所有基本功能，无论是个人还是商业用途，都整合到一个便捷的位置。",
    "about.philosophy.content3":
      "为什么我们免费提供这些图片编辑工具？我们相信应该让每个人都能获得高质量的图片编辑工具。每个人都应该能够获得免费解决方案，同时不牺牲质量。",

    // Privacy Page
    "privacy.title": "隐私政策",
    "privacy.intro":
      "在图片转换工具中，picmodifier.com 重视您的隐私并致力于保护您的个人信息。本隐私政策说明了 picmodifier.com 在您使用 picmodifier.com 服务时如何处理您的数据。picmodifier.com 要强调的是，picmodifier.com 不会收集或存储任何客户个人信息。",
    "privacy.info.title": "1. picmodifier.com 处理的信息",
    "privacy.info.image.title": "1.1 图片数据：",
    "privacy.info.image.content":
      "当您使用 picmodifier.com 的图片转换服务时，您的图片完全在您的浏览器中处理。picmodifier.com 不会在 picmodifier.com 的服务器上存储您的图片，它们会在处理完成后自动删除。",
    "privacy.info.personal.title": "1.2 不收集个人信息：",
    "privacy.info.personal.content":
      "picmodifier.com 不会从 picmodifier.com 用户那里收集任何个人信息。您可以在不提供任何个人详细信息的情况下使用 picmodifier.com 的服务。",
    "privacy.info.usage.title": "1.3 匿名使用数据：",
    "privacy.info.usage.content":
      "picmodifier.com 仅收集匿名使用数据，如浏览器类型、引用/退出页面和日期/时间戳。这些信息仅用于改进 picmodifier.com 的服务和用户体验。不会收集或存储任何个人标识符。",
    "privacy.info.cookies.title": "1.4 Cookie：",
    "privacy.info.cookies.content":
      "picmodifier.com 使用最少的 cookie 来增强您在 picmodifier.com 网站上的体验。这些 cookie 不会跟踪个人信息。您可以设置浏览器拒绝所有或部分浏览器 cookie，但这可能会影响功能。",
    "privacy.use.title": "2. picmodifier.com 如何使用信息",
    "privacy.use.service.title": "2.1 服务提供：",
    "privacy.use.service.content":
      "picmodifier.com 仅使用这些信息来提供和维护 picmodifier.com 的服务，包括按要求执行图片转换。所有处理都在您的浏览器中本地完成。",
    "privacy.use.improve.title": "2.2 服务改进：",
    "privacy.use.improve.content":
      "picmodifier.com 分析匿名使用模式以改进 picmodifier.com 的网站、产品和服务。此分析不涉及任何个人信息。",
    "privacy.use.communications.title": "2.3 通信：",
    "privacy.use.communications.content":
      "如果您选择联系 picmodifier.com，picmodifier.com 将仅使用您提供的联系信息来回应您的具体询问。picmodifier.com 不会出于营销目的存储此信息。",
    "privacy.security.title": "3. 数据安全",
    "privacy.security.content":
      "picmodifier.com 实施适当的安全措施来保护您的个人信息。但是，通过互联网传输或电子存储的方法都不是 100% 安全的。虽然 picmodifier.com 努力使用商业上可接受的手段来保护您的数据，但 picmodifier.com 不能保证其绝对安全。",
    "privacy.thirdparty.title": "4. 第三方服务",
    "privacy.thirdparty.content":
      "picmodifier.com 的服务可能包含指向第三方网站或服务的链接，这些网站或服务不属于 picmodifier.com 所有或控制。picmodifier.com 对任何第三方网站或服务的内容、隐私政策或做法没有控制权，也不承担任何责任。",
    "privacy.children.title": "5. 儿童隐私",
    "privacy.children.content":
      "picmodifier.com 的服务不适用于 13 岁以下的儿童。picmodifier.com 不会故意收集 13 岁以下儿童的个人身份信息。如果您是父母或监护人，并认为您的孩子向 picmodifier.com 提供了个人信息，请立即联系 picmodifier.com。",
    "privacy.changes.title": "6. 隐私政策变更",
    "privacy.changes.content":
      "picmodifier.com 可能会不时更新 picmodifier.com 的隐私政策。picmodifier.com 将通过在此页面上发布新的隐私政策来通知您任何更改。建议您定期查看本隐私政策的任何更改。",
    "privacy.contact.title": "7. 联系 picmodifier.com",
    "privacy.contact.content":
      "如果您对本隐私政策有任何疑问，请通过 picmodifier@outlook.com 联系 picmodifier.com。",
    "privacy.last.updated": "最后更新：{date}",

    // Terms Page
    "terms.title": "服务条款",
    "terms.welcome":
      "欢迎使用 picmodifier.com。通过访问或使用 picmodifier.com 服务，即表示您同意受这些服务条款的约束。在使用 picmodifier.com 服务之前，请仔细阅读这些条款。",
    "terms.acceptance.title": "1. 条款接受",
    "terms.acceptance.content":
      "通过访问或使用 picmodifier.com 服务，即表示您同意受这些服务条款和所有适用法律法规的约束。如果您不同意这些条款中的任何一条，则禁止使用或访问 picmodifier.com 服务。",
    "terms.license.title": "2. 使用许可",
    "terms.license.permission.title": "2.1 许可：",
    "terms.license.permission.content":
      "picmodifier.com 授予您有限的、非独占的、不可转让的许可，用于个人、非商业目的使用 picmodifier.com 服务。",
    "terms.license.restrictions.title": "2.2 限制：",
    "terms.license.restrictions.content": "您不得：",
    "terms.license.restrictions.list":
      '• 修改或复制材料\n• 将材料用于任何商业目的\n• 尝试反编译或反向工程 picmodifier.com 服务中包含的任何软件\n• 从材料中删除任何版权或其他专有标记\n• 将材料转移给他人或在任何其他服务器上"镜像"材料',
    "terms.content.title": "3. 用户内容",
    "terms.content.ownership.title": "3.1 所有权：",
    "terms.content.ownership.content":
      "您保留对您内容的所有权利。通过使用 picmodifier.com 服务，您授予 picmodifier.com 有限的许可，仅用于提供服务的目的处理您的内容。",
    "terms.content.prohibited.title": "3.2 禁止内容：",
    "terms.content.prohibited.content":
      "您同意不上传、处理或分享任何以下内容：",
    "terms.content.prohibited.list":
      "• 违反任何法律或法规\n• 侵犯知识产权\n• 包含有害或恶意代码\n• 不适当、冒犯性或侵犯任何第三方权利",
    "terms.disclaimer.title": "4. 免责声明",
    "terms.disclaimer.content":
      'picmodifier.com 服务按"原样"提供。picmodifier.com 不作任何明示或暗示的保证，并在此否认和否定所有其他保证，包括但不限于对适销性、特定用途适用性、知识产权非侵权或其他权利侵犯的默示保证或条件。',
    "terms.limitations.title": "5. 限制",
    "terms.limitations.content":
      "在任何情况下，picmodifier.com 或其供应商均不对因使用或无法使用 picmodifier.com 服务而导致的任何损害（包括但不限于数据或利润损失，或因业务中断造成的损失）承担责任。",
    "terms.accuracy.title": "6. 材料准确性",
    "terms.accuracy.content":
      "picmodifier.com 服务上出现的材料可能包含技术、排版或摄影错误。picmodifier.com 不保证 picmodifier.com 服务上的任何材料都是准确、完整或最新的。picmodifier.com 可以随时更改 picmodifier.com 服务上包含的材料，恕不另行通知。",
    "terms.links.title": "7. 链接",
    "terms.links.content":
      "picmodifier.com 尚未审查链接到 picmodifier.com 服务的所有网站，不对任何此类链接网站的内容负责。包含任何链接并不意味着 picmodifier.com 对该网站的认可。使用任何此类链接网站的风险由用户自行承担。",
    "terms.modifications.title": "8. 修改",
    "terms.modifications.content":
      "picmodifier.com 可以随时修改这些服务条款，恕不另行通知。通过使用 picmodifier.com 服务，您同意受当时版本的服务条款约束。",
    "terms.governing.title": "9. 适用法律",
    "terms.governing.content":
      "这些条款和条件受法律管辖并按照法律解释，您不可撤销地服从该地区法院的专属管辖权。",
    "terms.contact.title": "10. 联系 picmodifier.com",
    "terms.contact.content":
      "如果您对这些服务条款有任何疑问，请通过 picmodifier@outlook.com 联系 picmodifier.com。",
    "terms.last.updated": "最后更新：{date}",
  },
  de: {
    // Header
    "nav.home": "Startseite",
    "nav.about": "Über Uns",
    "nav.terms": "Nutzungsbedingungen",
    "nav.privacy": "Datenschutz",

    // Homepage
    "home.title": "Leistungsstarker Online-Bildkonverter",
    "home.subtitle":
      "Suchen Sie nach einem nützlichen und kostenlosen Tool zum Konvertieren von Bildformaten, wie JPG zu PNG, WEBP zu JPG?",
    "home.subtitle2":
      "Glückwunsch, Sie haben es gefunden! Dies ist die Website, nach der Sie gesucht haben.",
    "home.tools.description":
      "Wir bieten praktische, schnelle und umfassende Tools",
    "home.platform.description":
      "Nutzen Sie unsere All-in-One-Plattform, um die Effizienz zu steigern und eine intelligentere Bildformatkonvertierung zu erreichen.",
    "home.simplify.tasks": "Vereinfachen Sie Ihre grundlegenden Aufgaben",
    "home.conversion.steps":
      "Sie benötigen nur wenige einfache Schritte, um Bilder in hochwertige Formate zu konvertieren.",
    "home.resize.title": "Bilder in der Größe ändern",
    "home.convert.title": "Formate konvertieren",
    "home.compress.title": "Bilder komprimieren",
    "home.resize.now": "Jetzt Größe ändern",
    "home.compress.now": "Jetzt komprimieren",

    // Common
    "common.upload": "Hochladen",
    "common.convert": "Konvertieren",
    "common.download": "Herunterladen",
    "common.or": "oder",
    "common.drag": "ziehen",
    "common.file": "Datei",
    "common.to": "zu",
    "common.this": "diesem",
    "common.area": "Bereich",
    "common.toUpload": "zum Hochladen",
    "common.convertNow": "Jetzt konvertieren",
    "common.close": "Schließen",
    "common.dimensions": "Abmessungen: ",
    "common.file.size": "Dateigröße: ",
    "common.image.load.failed": "Bild konnte nicht geladen werden",

    // Resize Page
    "resize.upload.title": "Bild hochladen",
    "resize.original.dimensions": "Originalabmessungen: ",
    "resize.supported.formats": "Unterstützte Formate: ",
    "resize.format.original": "Originalformat",
    "resize.status.processing": "Bild wird in der Größe geändert...",
    "resize.status.complete":
      "Größenänderung abgeschlossen! Download wird vorbereitet...",
    "resize.download.button": "Größe ändern & Herunterladen",
    "resize.options.title": "Größenänderungsoptionen",
    "resize.width.label": "Breite (px)",
    "resize.height.label": "Höhe (px)",
    "resize.width.required": "Bitte Breite eingeben",
    "resize.height.required": "Bitte Höhe eingeben",
    "resize.percentage.required": "Bitte Prozentsatz eingeben",
    "resize.aspect.ratio": "Seitenverhältnis beibehalten",
    "resize.output.format": "Ausgabeformat",
    "resize.success.title": "Größenänderung erfolgreich!",
    "resize.method.label": "Größenänderungsmethode",
    "resize.scale.percentage": "Skalierungsprozentsatz",
    "resize.percentage.message": "Bitte Prozentsatz eingeben",
    "resize.original.image": "Originalbild",
    "resize.resized.image": "Größenverändertes Bild",
    "resize.estimated.size": "Geschätzte Dateigröße: {size} KB",
    "resize.download.resized": "Größenverändertes Bild herunterladen",
    "resize.success.message":
      "Ihr Bild wurde erfolgreich in der Größe geändert.",
    "resize.download.hint":
      "Klicken Sie auf die Schaltfläche Herunterladen, um das größenveränderte Bild auf Ihrem Gerät zu speichern.",
    "resize.preview.hint":
      "Sie können das Ergebnis auch im Vorschaubereich anzeigen.",

    // Compress Page
    "compress.upload.title": "Bild hochladen",
    "compress.upload.description":
      "Laden Sie Ihr Bild hoch und klicken Sie auf Komprimieren, um die Dateigröße zu reduzieren und dabei die visuelle Qualität beizubehalten.",
    "compress.tool.description":
      "Dieses Tool komprimiert {format}-Bilder mit fortschrittlichen Algorithmen",
    "compress.upload.complete": "Upload abgeschlossen: {filename}",
    "compress.original.size": "Originalgröße: {size}",
    "compress.technology.description":
      "{description} mit Hochleistungs-Komprimierungstechnologie.",
    "compress.upload.hint":
      "Klicken oder ziehen Sie die {format}-Datei in diesen Bereich zum Hochladen",
    "compress.upload.format.hint":
      "Nur {format}-Dateien werden für die Komprimierung akzeptiert.",
    "compress.status": "Bild wird komprimiert...",
    "compress.download.button": "Komprimieren & Herunterladen",
    "compress.back.home": "Zurück zur Startseite",
    "compress.complete": "Komprimierung abgeschlossen",
    "compress.compressed.size": "Komprimierte Größe: {size}",
    "compress.reduction": "Reduzierung: {percentage}%",
    "compress.download.again": "Herunterladen",
    "compress.comparison.title": "Vorher- und Nachher-Vergleich",
    "compress.comparison.original": "Original",
    "compress.comparison.compressed": "Komprimiert",

    // Detail Page
    "detail.upload.required": "Bitte laden Sie ein Bild hoch!",
    "detail.convert.success": "Erfolgreich konvertiert: {format}",
    "detail.convert.error":
      "Konvertierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "detail.upload.description":
      "Bitte laden Sie eine {fromFormat}-Datei hoch und klicken Sie auf Konvertieren. Die konvertierte {toFormat}-Datei wird automatisch heruntergeladen.",
    "detail.step1.title": "1. Bild hochladen",
    "detail.upload.complete": "Upload abgeschlossen: {filename}",
    "detail.upload.change":
      "Klicken Sie hier, um eine andere Datei hochzuladen oder zur Konvertierung fortzufahren",
    "detail.upload.hint":
      "Klicken oder ziehen Sie die {format}-Datei in diesen Bereich zum Hochladen",
    "detail.upload.format.hint":
      "Nur {format}-Dateien werden für diese Konvertierung akzeptiert.",
    "detail.step2.title": "2. Konvertieren & Herunterladen",
    "detail.convert.button": "Konvertieren & Herunterladen",
    "detail.conversion.complete":
      "✓ Konvertierung abgeschlossen! Ihre Datei wurde automatisch heruntergeladen.",
    "detail.upload.status": "Upload abgeschlossen",
    "detail.upload.success": "Die Datei wurde erfolgreich hochgeladen.",
    "detail.upload.proceed":
      "Sie können jetzt Ihre {fromFormat}-Datei in {toFormat} konvertieren.",

    // Footer
    "footer.support.email": "Kundensupport Email: picmodifier@outlook.com",

    // Resize
    "resize.exact.name": "Genaueste Abmessungen",
    "resize.exact.description": "Bild auf bestimmte Breite und Höhe skalieren",
    "resize.width.name": "Nach Breite",
    "resize.width.description":
      "Bild auf bestimmte Breite skalieren, Seitenverhältnis beibehalten",
    "resize.height.name": "Nach Höhe",
    "resize.height.description":
      "Bild auf bestimmte Höhe skalieren, Seitenverhältnis beibehalten",
    "resize.percentage.name": "Nach Prozentsatz",
    "resize.percentage.description": "Bild um bestimmten Prozentsatz skalieren",
    "resize.format.jpg.name": "JPG-Bildgröße",
    "resize.format.jpg.description":
      "JPG-Bilder auf Ihre bevorzugten Abmessungen skalieren, während die Qualität erhalten bleibt. Ideal für Web- und Shared-Nutzer.",
    "resize.format.jpeg.name": "JPEG-Bildgröße",
    "resize.format.jpeg.description":
      "JPEG-Bilder auf Ihre Anforderungen skalieren. Ideal für Webseiten, Dokumente und Präsentationen.",
    "resize.format.png.name": "PNG-Bildgröße",
    "resize.format.png.description":
      "PNG-Bilder mit Transparenz skalieren. Ideal für Logos, Icons und Grafiken, die eine Größenanpassung benötigen.",

    // Compress
    "compress.jpg.name": "JPG-Komprimierung",
    "compress.jpg.description":
      "Optimieren Sie JPG-Bilder für schnellere Web-Ladung und reduzierte Speicherung. Ideal für Fotos und komplexe Bilder.",
    "compress.jpeg.name": "JPEG-Komprimierung",
    "compress.jpeg.description":
      "Reduzieren Sie die Dateigröße von JPEGs für E-Mail-Anhänge und Web-Freigabe. Die visuelle Qualität bleibt bei kleineren Größen erhalten.",
    "compress.png.name": "PNG-Komprimierung",
    "compress.png.description":
      "Reduzieren Sie die Dateigröße von PNGs, während die Qualität und Transparenz für Logos, Icons und Grafiken erhalten bleibt.",

    // Convert
    "convert.webp.jpeg":
      "WebP zu JPEG konvertieren, um eine bessere Kompatibilität mit älteren Browsern und Anwendungen zu erreichen",
    "convert.webp.jpg":
      "WebP zu JPG konvertieren, um eine bessere Kompatibilität mit allen Geräten und Anwendungen zu erreichen",
    "convert.webp.png":
      "WebP zu PNG konvertieren, um eine verlustfreie Bildqualität mit Transparenzunterstützung zu erreichen",
    "convert.webp.ico":
      "WebP zu ICO konvertieren, um Website-Favicons und Anwendungs-Icons zu erstellen",
    "convert.webp.bmp":
      "WebP zu BMP konvertieren, um eine Kompatibilität mit älteren Windows-Anwendungen zu erreichen",
    "convert.webp.apng":
      "WebP zu APNG konvertieren, um animierte Bilder mit Transparenzunterstützung zu erstellen",

    "convert.jpeg.webp":
      "JPEG zu WebP konvertieren, um eine kleinere Dateigröße und bessere Web-Leistung zu erreichen",
    "convert.jpeg.jpg": "JPEG zu JPG (gleiche Dateiformat, andere Erweiterung)",
    "convert.jpeg.png":
      "JPEG zu PNG konvertieren, um eine bessere Bildqualität und Transparenzunterstützung zu erreichen",
    "convert.jpeg.ico":
      "JPEG zu ICO konvertieren, um Website-Icons und Anwendungs-Icons zu erstellen",
    "convert.jpeg.bmp":
      "JPEG zu BMP konvertieren, um eine Kompatibilität mit älteren Windows-Anwendungen zu erreichen",
    "convert.jpeg.apng":
      "JPEG zu APNG konvertieren, um grundlegende Animationsunterstützung zu erstellen",

    "convert.jpg.webp":
      "JPG zu WebP konvertieren, um eine kleinere Dateigröße und bessere Web-Leistung zu erreichen",
    "convert.jpg.jpeg": "JPG zu JPEG (gleiche Dateiformat, andere Erweiterung)",
    "convert.jpg.png":
      "JPG zu PNG konvertieren, um eine bessere Bildqualität und Transparenzunterstützung zu erreichen",
    "convert.jpg.ico":
      "JPG zu ICO konvertieren, um Website-Icons und Anwendungs-Icons zu erstellen",
    "convert.jpg.bmp":
      "JPG zu BMP konvertieren, um eine Kompatibilität mit älteren Windows-Anwendungen zu erreichen",
    "convert.jpg.apng":
      "JPG zu APNG konvertieren, um grundlegende Animationsunterstützung zu erstellen",

    "convert.png.webp":
      "PNG zu WebP konvertieren, um eine kleinere Dateigröße und Transparenz zu erreichen",
    "convert.png.jpeg":
      "PNG zu JPEG konvertieren, um eine kleinere Dateigröße (beachten Sie: Transparenz geht verloren) zu erreichen",
    "convert.png.jpg":
      "PNG zu JPG konvertieren, um eine kleinere Dateigröße und bessere Kompatibilität zu erreichen",
    "convert.png.ico":
      "PNG zu ICO konvertieren, um Website-Icons und Anwendungs-Icons zu erstellen",
    "convert.png.bmp":
      "PNG zu BMP konvertieren, um eine Kompatibilität mit älteren Windows-Anwendungen zu erreichen",
    "convert.png.apng": "PNG zu APNG konvertieren, um Animationen hinzuzufügen",

    "convert.ico.webp":
      "ICO zu WebP konvertieren, um eine bessere Komprimierung und moderne Web-Nutzung zu erreichen",
    "convert.ico.jpeg":
      "ICO zu JPEG konvertieren, um eine bessere Kompatibilität mit Foto-Editoren zu erreichen",
    "convert.ico.jpg":
      "ICO zu JPG konvertieren, um eine bessere Kompatibilität mit allen Geräten und Anwendungen zu erreichen",
    "convert.ico.png":
      "ICO zu PNG konvertieren, um eine bessere Bildqualität und modernen Format zu erreichen",
    "convert.ico.bmp":
      "ICO zu BMP konvertieren, um eine Kompatibilität mit älteren Windows-Anwendungen zu erreichen",
    "convert.ico.apng":
      "ICO zu APNG konvertieren, um Icons mit Animationen zu versehen",

    "convert.bmp.webp":
      "BMP zu WebP konvertieren, um eine kleinere Dateigröße und bessere Web-Leistung zu erreichen",
    "convert.bmp.jpeg":
      "BMP zu JPEG konvertieren, um eine kleinere Dateigröße und bessere Kompatibilität zu erreichen",
    "convert.bmp.jpg":
      "BMP zu JPG konvertieren, um eine kleinere Dateigröße und bessere Kompatibilität zu erreichen",
    "convert.bmp.png":
      "BMP zu PNG konvertieren, um eine verlustfreie Komprimierung und Transparenzunterstützung zu erreichen",
    "convert.bmp.ico":
      "BMP zu ICO konvertieren, um Website-Icons und Anwendungs-Icons zu erstellen",
    "convert.bmp.apng": "BMP zu APNG konvertieren, um Animationen hinzuzufügen",

    "convert.apng.webp":
      "APNG zu WebP konvertieren, um eine bessere Komprimierung und Animation zu erreichen",
    "convert.apng.jpeg":
      "APNG zu JPEG (beachten Sie: Animation und Transparenz gehen verloren) konvertieren",
    "convert.apng.jpg":
      "APNG zu JPG (beachten Sie: Animation und Transparenz gehen verloren) konvertieren",
    "convert.apng.png":
      "APNG zu PNG (beachten Sie: Animation geht verloren, aber Transparenz bleibt erhalten) konvertieren",
    "convert.apng.ico":
      "APNG zu ICO (beachten Sie: Animation geht verloren) konvertieren",
    "convert.apng.bmp":
      "APNG zu BMP (Animation und Transparenz gehen verloren) konvertieren",

    // About Page
    "about.title": "About Us",
    "about.welcome":
      "Willkommen bei Image Converter, Ihrem Tool für alle Bildkonvertierungsbedürfnisse. Wir haben diese Plattform erstellt, um Ihnen eine einfache, aber leistungsstarke Lösung für das Konvertieren von Bildformaten zwischen verschiedenen Formaten zu bieten.",
    "about.mission.title": "Unsere Mission",
    "about.mission.content":
      "Unsere Mission ist es, jedermann zugänglich zu machen, Bildkonvertierung zu sein. Egal ob Sie ein professioneller Designer, Entwickler oder nur jemanden sind, der ein Bild von Zeit zu Zeit konvertieren muss, wir haben Sie abgedeckt. Wir streben danach, Ihnen einen benutzerfreundlichen Service zu bieten, der Bildkonvertierungen ohne die Notwendigkeit spezialisierter Software oder technischer Kenntnisse liefert.",
    "about.why.title": "Warum wählen Sie uns?",
    "about.fast.title": "Schnelle Konvertierung",
    "about.fast.content":
      "Unser Konvertierungs-Engine ist für Geschwindigkeit optimiert, sodass Sie Ihre Bilder in Sekunden konvertieren können.",
    "about.privacy.title": "Datenschutz zuerst",
    "about.privacy.content":
      "Ihr Datenschutz ist uns wichtig. Alle Bildverarbeitungen passieren in Ihrem Browser, und wir speichern Ihre Bilder nicht auf unseren Servern.",
    "about.noinstall.title": "Keine Installation erforderlich",
    "about.noinstall.content":
      "Sie können unser Tool von jedem Gerät aus mit einem Webbrowser verwenden. Es ist nicht notwendig, zusätzliche Software zu installieren.",
    "about.userfriendly.title": "Benutzerfreundlich",
    "about.userfriendly.content":
      "Wir haben unsere Oberfläche so gestaltet, dass sie intuitiv und einfach zu bedienen ist, unabhängig von Ihrer technischen Expertise.",
    "about.team.title": "Unser Team",
    "about.team.content":
      "Wir sind ein kleines Team von leidenschaftlichen Entwicklern und Designerinnen, das daran arbeitet, Werkzeuge zu schaffen, die das Leben leichter machen. Unsere verschiedenen Hintergründe im Webentwicklung, UI/UX-Design und Bildverarbeitung ermöglichen es uns, ein Werkzeug zu schaffen, das sowohl technische Exzellenz als auch Benutzerfreundlichkeit vereint.",
    "about.team.lead": "Lead Developer",
    "about.team.designer": "UI/UX-Designer",
    "about.team.expert": "Bildverarbeitungsexperte",
    "about.philosophy.title": "Unser Philosophie",
    "about.philosophy.content1":
      "Wir vereinfachen die Online-Bildverarbeitung und -konvertierung, indem wir eine schnelle und einfache Lösung bieten. Unsere Plattform wurde erstellt, um die Notwendigkeit, Software herunterzuladen, zu beseitigen, was für die meisten Benutzer ein häufiges Problem darstellt, wenn es um das Verarbeiten von Bildern geht.",
    "about.philosophy.content2":
      "Wir haben alle wichtigen Funktionen integriert, die für das Verarbeiten von Bildern erforderlich sind, egal ob es sich um persönliche oder geschäftliche Nutzung handelt, in eine einheitliche Lage.",
    "about.philosophy.content3":
      "Warum bieten wir diese Bildbearbeitungstools kostenlos an? Wir glauben, dass es jedermann ermöglichen sollte, hochwertige Bildbearbeitungstools kostenlos zu verwenden. Jeder sollte in der Lage sein, eine kostenlose Lösung zu erhalten, ohne die Qualität zu vernachlässigen.",

    // Privacy Page
    "privacy.title": "Datenschutzrichtlinie",
    "privacy.intro":
      "Bei Image Converter, picmodifier.com schätzen wir Ihren Datenschutz und sind verpflichtet, Ihre persönlichen Daten zu schützen. Diese Datenschutzrichtlinie erklärt, wie picmodifier.com Ihre Daten verarbeitet, wenn Sie picmodifier.com-Service verwenden. picmodifier.com möchten betonen, dass picmodifier.com keine persönlichen Kundendaten sammelt oder speichert.",
    "privacy.info.title": "1. picmodifier.com verarbeitete Informationen",
    "privacy.info.image.title": "1.1 Bilddaten:",
    "privacy.info.image.content":
      "Wenn Sie picmodifier.com-Bildkonvertierungsdienst verwenden, werden Ihre Bilder vollständig in Ihrem Browser verarbeitet. picmodifier.com speichert Ihre Bilder nicht auf picmodifier.com-Servern, und sie werden automatisch nach der Verarbeitung gelöscht.",
    "privacy.info.personal.title": "1.2 Keine persönlichen Daten gesammelt:",
    "privacy.info.personal.content":
      "picmodifier.com sammelt keine persönlichen Daten von picmodifier.com-Benutzern. Sie können picmodifier.com-Service ohne Angabe persönlicher Details verwenden.",
    "privacy.info.usage.title": "1.3 Anonyme Nutzungsdaten:",
    "privacy.info.usage.content":
      "picmodifier.com sammelt nur anonyme Nutzungsdaten wie Browser-Typ, Verweis-/Exit-Seiten und Datum/Uhrzeit-Stempel. Diese Informationen werden ausschließlich verwendet, um picmodifier.com-Service und die Benutzererfahrung zu verbessern. Es werden keine persönlichen Identifikatoren gesammelt oder gespeichert.",
    "privacy.info.cookies.title": "1.4 Cookies:",
    "privacy.info.cookies.content":
      "picmodifier.com verwendet minimalen Cookies, um Ihre Erfahrung auf picmodifier.com-Site zu verbessern. Diese Cookies verfolgen keine personenbezogenen Daten. Sie können Ihren Browser so einrichten, dass er alle oder einige Browser-Cookies ablehnt, dies kann jedoch die Funktionalität beeinträchtigen.",
    "privacy.use.title": "2. Wie verwendet picmodifier.com Informationen",
    "privacy.use.service.title": "2.1 Dienstleistung:",
    "privacy.use.service.content":
      "picmodifier.com verwendet nur diese Informationen, um picmodifier.com-Service bereitzustellen und aufrechtzuerhalten, einschließlich der Bildkonvertierung auf Anfrage. Alle Verarbeitungen werden lokal in Ihrem Browser durchgeführt.",
    "privacy.use.improve.title": "2.2 Dienstverbesserung:",
    "privacy.use.improve.content":
      "picmodifier.com analysiert anonyme Nutzungsmuster, um picmodifier.com-Website, Produkte und Dienste zu verbessern. Diese Analyse betrifft keine personenbezogenen Daten.",
    "privacy.use.communications.title": "2.3 Kommunikation:",
    "privacy.use.communications.content":
      "Wenn Sie picmodifier.com kontaktieren möchten, verwendet picmodifier.com nur die von Ihnen bereitgestellten Kontaktdaten, um Ihre spezifische Frage zu beantworten. picmodifier.com speichert diese Informationen nicht für Werbezwecke.",
    "privacy.security.title": "3. Datensicherheit",
    "privacy.security.content":
      "picmodifier.com setzt angemessene Sicherheitsmaßnahmen zur Schutz Ihrer persönlichen Daten um. Es gibt jedoch keine 100%-ige Sicherheit bei der Übertragung über das Internet oder der elektronischen Speicherung. Während picmodifier.com versucht, mit kommerziell akzeptablen Mitteln zu arbeiten, um Ihre Daten zu schützen, kann picmodifier.com es nicht garantieren, dass es absolut sicher ist.",
    "privacy.thirdparty.title": "4. Dritte-Party-Dienste",
    "privacy.thirdparty.content":
      "picmodifier.com-Dienste können Links zu Drittanbieter-Websites oder -Diensten enthalten, die nicht zu picmodifier.com gehören oder von picmodifier.com kontrolliert werden. picmodifier.com hat keinen Einfluss auf die Inhalte, die Datenschutzrichtlinien oder die Praktiken von Drittanbieter-Websites oder -Diensten. picmodifier.com übernimmt keine Verantwortung für die Inhalte, die Datenschutzrichtlinien oder die Praktiken von Drittanbieter-Websites oder -Diensten.",
    "privacy.children.title": "5. Kinder-Datenschutz",
    "privacy.children.content":
      "picmodifier.com-Dienst ist nicht für Kinder unter 13 Jahren gedacht. picmodifier.com sammelt keine personenbezogenen Daten von Kindern unter 13 Jahren ausdrücklich. Wenn Sie Eltern oder Vormund sind und glauben, dass Ihr Kind picmodifier.com persönliche Daten bereitgestellt hat, wenden Sie sich bitte an picmodifier.com.",
    "privacy.changes.title": "6. Änderungen an dieser Datenschutzrichtlinie",
    "privacy.changes.content":
      "picmodifier.com kann diese Datenschutzrichtlinie von Zeit zu Zeit aktualisieren. picmodifier.com wird Sie darüber informieren, indem es eine neue Datenschutzrichtlinie auf dieser Seite veröffentlicht. Es wird empfohlen, diese Datenschutzrichtlinie regelmäßig zu überprüfen.",
    "privacy.contact.title": "7. Kontakt picmodifier.com",
    "privacy.contact.content":
      "Wenn Sie Fragen zu dieser Datenschutzrichtlinie haben, wenden Sie sich bitte an picmodifier.com unter picmodifier@outlook.com.",
    "privacy.last.updated": "Zuletzt aktualisiert: {date}",

    // Terms Page
    "terms.title": "Nutzungsbedingungen",
    "terms.welcome":
      "Willkommen bei picmodifier.com. Durch das Zugriffen oder Verwenden von picmodifier.com-Service, stimmen Sie den Nutzungsbedingungen zu. Bitte lesen Sie diese Bedingungen sorgfältig, bevor Sie picmodifier.com-Service verwenden.",
    "terms.acceptance.title": "1. Zustimmung zu den Nutzungsbedingungen",
    "terms.acceptance.content":
      "Durch das Zugriffen oder Verwenden von picmodifier.com-Service, stimmen Sie den Nutzungsbedingungen und allen anwendbaren Gesetzen und Vorschriften zu. Wenn Sie mit keiner dieser Bedingungen einverstanden sind, sind Sie von der Nutzung oder dem Zugriff auf picmodifier.com-Service ausgeschlossen.",
    "terms.license.title": "2. Nutzungsrecht",
    "terms.license.permission.title": "2.1 Erlaubnis:",
    "terms.license.permission.content":
      "picmodifier.com gewährt Ihnen eine beschränkte, nicht exklusive, nicht übertragbare Erlaubnis, picmodifier.com-Service für persönliche, nicht kommerzielle Zwecke zu verwenden.",
    "terms.license.restrictions.title": "2.2 Einschränkungen:",
    "terms.license.restrictions.content": "Sie dürfen nicht:",
    "terms.license.restrictions.list":
      '• Materialien zu ändern oder zu kopieren\n• Materialien für jedwede kommerzielle Zwecke zu verwenden\n• Versuchen Sie, die Software in picmodifier.com-Service zu dekompilieren oder zu reverse-engineering\n• Urheberrechts- oder sonstige eigene Merkmale von Materialien zu entfernen\n• Materialien an eine andere Person oder "Spiegelung" von Materialien auf einem anderen Server',
    "terms.content.title": "3. Nutzungsbeitrag",
    "terms.content.ownership.title": "3.1 Eigentum:",
    "terms.content.ownership.content":
      "Sie behalten alle Rechte an Ihrem Inhalt. Durch das Verwenden von picmodifier.com-Service gewähren Sie picmodifier.com eine beschränkte Lizenz, Ihren Inhalt ausschließlich für den Zweck der Bereitstellung des Dienstes zu verarbeiten.",
    "terms.content.prohibited.title": "3.2 Verbotene Inhalte:",
    "terms.content.prohibited.content":
      "Sie stimmen nicht zu, Inhalte hochzuladen, zu verarbeiten oder zu teilen, die:",
    "terms.content.prohibited.list":
      "• Verletzung von Gesetzen oder Vorschriften\n• Verletzung von geistigen Eigentumsrechten\n• Enthalten von schädlichen oder bösartigen Code\n• Sind unangemessen, anstößig oder verletzen die Rechte von Dritten",
    "terms.disclaimer.title": "4. Haftungsausschluss",
    "terms.disclaimer.content":
      'picmodifier.com-Service wird "so wie es ist" bereitgestellt. picmodifier.com macht keine Gewährleistungen, ausgesprochen oder stillschweigend, und hierdurch verschweigt picmodifier.com und negiert alle anderen Gewährleistungen, einschließlich ohne beschränkende Bedingungen, dass die Verkaufs- oder Bestimmungsfähigkeit, die Eignung für einen bestimmten Zweck oder die Nichtverletzung von geistigen Eigentumsrechten oder anderen Rechtsverletzungen implizit garantiert oder verschweigt werden.',
    "terms.limitations.title": "5. Grenzen",
    "terms.limitations.content":
      "In keinem Fall sind picmodifier.com oder picmodifier.com-Lieferanten für Schäden (einschließlich, aber nicht beschränkt auf Datenverlust oder Gewinn, oder aufgrund von Geschäftsunterbrechung) aufgrund der Nutzung oder Nichtnutzung von picmodifier.com-Service verantwortlich.",
    "terms.accuracy.title": "6. Genauigkeit der Materialien",
    "terms.accuracy.content":
      "Die auf picmodifier.com-Service angezeigten Materialien können technische, typografische oder fotografische Fehler enthalten. picmodifier.com garantiert nicht, dass alle Materialien auf picmodifier.com-Service genau, vollständig oder aktuell sind. picmodifier.com kann jederzeit Änderungen an den auf picmodifier.com-Service enthaltenen Materialien vornehmen, ohne vorher zu informieren.",
    "terms.links.title": "7. Links",
    "terms.links.content":
      "picmodifier.com hat nicht alle auf picmodifier.com-Service verlinkten Websites überprüft und übernimmt keine Verantwortung für die Inhalte von Websites, auf die verlinkt wird. Die Aufnahme von Links bedeutet nicht, dass picmodifier.com die Website oder deren Inhalt zustimmt. Die Verwendung von Websites, auf die verlinkt wird, erfolgt auf Ihr eigenes Risiko.",
    "terms.modifications.title": "8. Modifikationen",
    "terms.modifications.content":
      "picmodifier.com kann diese Nutzungsbedingungen jederzeit ohne vorherige Ankündigung ändern. Durch das Verwenden von picmodifier.com-Service stimmen Sie der Version dieser Nutzungsbedingungen zu, die zu dem Zeitpunkt gültig ist, zu dem Sie picmodifier.com-Service verwenden.",
    "terms.governing.title": "9. Gesetzgebung",
    "terms.governing.content":
      "Diese Nutzungsbedingungen werden von den Gesetzen und Vorschriften in diesem Bereich kontrolliert und Sie unterwerfen sich aufgrund dieser Gesetze und Vorschriften der ausschließlichen Zuständigkeit der Gerichte in diesem Bereich.",
    "terms.contact.title": "10. Kontakt picmodifier.com",
    "terms.contact.content":
      "Wenn Sie Fragen zu diesen Nutzungsbedingungen haben, wenden Sie sich bitte an picmodifier.com unter picmodifier@outlook.com.",
    "terms.last.updated": "Zuletzt aktualisiert: {date}",
  },
  pt: {
    // Header
    "nav.home": "Início",
    "nav.about": "Sobre Nós",
    "nav.terms": "Termos e Condições",
    "nav.privacy": "Privacidade",

    // Homepage
    "home.title": "Conversor de Imagens Poderoso Online",
    "home.subtitle":
      "Está procurando uma ferramenta útil e gratuita para converter formatos de imagem, como JPG para PNG, WEBP para JPG?",
    "home.subtitle2":
      "Parabéns, você encontrou! Este é o site que você estava procurando.",
    "home.tools.description":
      "Fornecemos ferramentas convenientes, rápidas e abrangentes",
    "home.platform.description":
      "Use nossa plataforma completa para melhorar a eficiência e alcançar um processamento mais inteligente de conversão de formato de imagem.",
    "home.simplify.tasks": "Simplifique suas tarefas básicas",
    "home.conversion.steps":
      "Você só precisa de alguns passos simples para converter livremente imagens em formatos de alta qualidade.",
    "home.resize.title": "Redimensionar Imagens",
    "home.convert.title": "Converter Formatos",
    "home.compress.title": "Comprimir Imagens",
    "home.resize.now": "Redimensionar Agora",
    "home.compress.now": "Comprimir Agora",

    // Common
    "common.upload": "Enviar",
    "common.convert": "Converter",
    "common.download": "Baixar",
    "common.or": "ou",
    "common.drag": "arrastar",
    "common.file": "arquivo",
    "common.to": "para",
    "common.this": "esta",
    "common.area": "área",
    "common.toUpload": "para enviar",
    "common.convertNow": "Converter Agora",
    "common.close": "Fechar",
    "common.dimensions": "Dimensões: ",
    "common.file.size": "Tamanho do arquivo: ",
    "common.image.load.failed": "Falha ao carregar imagem",

    // Resize Page
    "resize.upload.title": "Envie Sua Imagem",
    "resize.original.dimensions": "Dimensões originais: ",
    "resize.supported.formats": "Formatos suportados: ",
    "resize.format.original": "Formato Original",
    "resize.status.processing": "Redimensionando sua imagem...",
    "resize.status.complete":
      "Redimensionamento completo! Preparando download...",
    "resize.download.button": "Redimensionar e Baixar",
    "resize.options.title": "Opções de Redimensionamento",
    "resize.width.label": "Largura (px)",
    "resize.height.label": "Altura (px)",
    "resize.width.required": "Por favor, insira a largura",
    "resize.height.required": "Por favor, insira a altura",
    "resize.percentage.required": "Por favor, insira a porcentagem",
    "resize.aspect.ratio": "Manter Proporção",
    "resize.output.format": "Formato de Saída",
    "resize.success.title": "Redimensionamento Bem-sucedido!",
    "resize.method.label": "Método de Redimensionamento",
    "resize.scale.percentage": "Porcentagem de Escala",
    "resize.percentage.message": "Por favor, insira a porcentagem",
    "resize.original.image": "Imagem Original",
    "resize.resized.image": "Imagem Redimensionada",
    "resize.estimated.size": "Tamanho estimado do arquivo: {size} KB",
    "resize.download.resized": "Baixar Imagem Redimensionada",
    "resize.success.message": "Sua imagem foi redimensionada com sucesso.",
    "resize.download.hint":
      "Clique no botão Baixar para salvar a imagem redimensionada em seu dispositivo.",
    "resize.preview.hint":
      "Você também pode visualizar o resultado na área de visualização.",

    // Compress Page
    "compress.upload.title": "Envie Sua Imagem",
    "compress.upload.description":
      "Envie sua imagem e clique em Comprimir para reduzir o tamanho do arquivo mantendo a qualidade visual.",
    "compress.tool.description":
      "Esta ferramenta comprime imagens {format} usando algoritmos avançados",
    "compress.upload.complete": "Upload Completo: {filename}",
    "compress.original.size": "Tamanho original: {size}",
    "compress.technology.description":
      "{description} usando tecnologia de compressão de alto desempenho.",
    "compress.upload.hint":
      "Clique ou arraste arquivo {format} para esta área para enviar",
    "compress.upload.format.hint":
      "Apenas arquivos {format} são aceitos para compressão.",
    "compress.status": "Comprimindo sua imagem...",
    "compress.download.button": "Comprimir e Baixar",
    "compress.back.home": "Voltar para Início",
    "compress.complete": "Compressão Completa",
    "compress.compressed.size": "Tamanho comprimido: {size}",
    "compress.reduction": "Redução: {percentage}%",
    "compress.download.again": "Baixar",
    "compress.comparison.title": "Comparação Antes e Depois",
    "compress.comparison.original": "Original",
    "compress.comparison.compressed": "Comprimido",

    // Detail Page
    "detail.upload.required": "Por favor, envie uma imagem primeiro!",
    "detail.convert.success": "Convertido com sucesso para {format}",
    "detail.convert.error":
      "Falha ao converter imagem. Por favor, tente novamente.",
    "detail.upload.description":
      "Por favor, envie um arquivo {fromFormat} e clique no botão Converter. O arquivo convertido {toFormat} será baixado automaticamente.",
    "detail.step1.title": "1. Envie Sua Imagem {format}",
    "detail.upload.complete": "Upload Completo: {filename}",
    "detail.upload.change":
      "Clique aqui para enviar um arquivo diferente ou prosseguir com a conversão",
    "detail.upload.hint":
      "Clique ou arraste arquivo {format} para esta área para enviar",
    "detail.upload.format.hint":
      "Apenas arquivos {format} são aceitos para esta conversão.",
    "detail.step2.title": "2. Converter e Baixar",
    "detail.convert.button": "Converter e Baixar",
    "detail.conversion.complete":
      "✓ Conversão completa! Seu arquivo foi baixado automaticamente.",
    "detail.upload.status": "Upload Completo",
    "detail.upload.success": "foi enviado com sucesso.",
    "detail.upload.proceed":
      "Agora você pode prosseguir para converter seu arquivo {fromFormat} para {toFormat}.",

    // Footer
    "footer.support.email":
      "Email de suporte ao cliente: picmodifier@outlook.com",

    // Resize
    "resize.exact.name": "Dimensões Exatas",
    "resize.exact.description":
      "Redimensionar para largura e altura específicas",
    "resize.width.name": "Por Largura",
    "resize.width.description":
      "Redimensionar para largura específica, mantendo a proporção",
    "resize.height.name": "Por Altura",
    "resize.height.description":
      "Redimensionar para altura específica, mantendo a proporção",
    "resize.percentage.name": "Por Porcentagem",
    "resize.percentage.description": "Escalar imagem por porcentagem",
    "resize.format.jpg.name": "Redimensionar JPG",
    "resize.format.jpg.description":
      "Redimensione imagens JPG para suas dimensões preferidas mantendo a qualidade. Perfeito para uso na web ou compartilhamento.",
    "resize.format.jpeg.name": "Redimensionar JPEG",
    "resize.format.jpeg.description":
      "Ajuste as dimensões JPEG para atender aos seus requisitos. Ideal para páginas web, documentos e apresentações.",
    "resize.format.png.name": "Redimensionar PNG",
    "resize.format.png.description":
      "Redimensione imagens PNG com transparência. Perfeito para logos, ícones e gráficos que precisam de ajuste de tamanho.",

    // Compress
    "compress.jpg.name": "Comprimir JPG",
    "compress.jpg.description":
      "Otimize imagens JPG para carregamento mais rápido na web e armazenamento reduzido. Perfeito para fotografias e imagens complexas.",
    "compress.jpeg.name": "Comprimir JPEG",
    "compress.jpeg.description":
      "Reduza o tamanho do arquivo JPEG para anexos de email e compartilhamento na web. Mantém boa qualidade visual em tamanhos menores.",
    "compress.png.name": "Comprimir PNG",
    "compress.png.description":
      "Reduza o tamanho do arquivo PNG mantendo a qualidade e transparência para logos, ícones e gráficos.",

    // Convert
    "convert.webp.jpeg":
      "Converta WebP para JPEG para melhor compatibilidade com navegadores e aplicativos mais antigos",
    "convert.webp.jpg":
      "Converta WebP para JPG para melhor compatibilidade com todos os dispositivos e aplicativos",
    "convert.webp.png":
      "Converta WebP para PNG para qualidade de imagem sem perdas com suporte a transparência",
    "convert.webp.ico":
      "Converta WebP para ICO para favicons de sites e ícones de aplicativos",
    "convert.webp.bmp":
      "Converta WebP para BMP para compatibilidade com aplicativos Windows mais antigos",
    "convert.webp.apng":
      "Converta WebP para APNG para imagens animadas com suporte a transparência",

    "convert.jpeg.webp":
      "Converta JPEG para WebP para tamanhos de arquivo menores e melhor desempenho na web",
    "convert.jpeg.jpg":
      "Converta JPEG para JPG (mesmo formato, extensão diferente)",
    "convert.jpeg.png":
      "Converta JPEG para PNG para melhor qualidade e suporte a transparência",
    "convert.jpeg.ico":
      "Converta JPEG para ICO para favicon e ícones de aplicativos",
    "convert.jpeg.bmp":
      "Converta JPEG para BMP para uso com aplicativos Windows mais antigos",
    "convert.jpeg.apng":
      "Converta JPEG para APNG para suporte básico a animação",

    "convert.jpg.webp":
      "Converta JPG para WebP para tamanhos de arquivo menores e melhor desempenho na web",
    "convert.jpg.jpeg":
      "Converta JPG para JPEG (mesmo formato, extensão diferente)",
    "convert.jpg.png":
      "Converta JPG para PNG para melhor qualidade e suporte a transparência",
    "convert.jpg.ico":
      "Converta JPG para ICO para favicon e ícones de aplicativos",
    "convert.jpg.bmp":
      "Converta JPG para BMP para uso com aplicativos Windows mais antigos",
    "convert.jpg.apng": "Converta JPG para APNG para suporte básico a animação",

    "convert.png.webp":
      "Converta PNG para WebP para tamanhos de arquivo menores mantendo a transparência",
    "convert.png.jpeg":
      "Converta PNG para JPEG para tamanhos de arquivo menores (nota: a transparência será perdida)",
    "convert.png.jpg":
      "Converta PNG para JPG para tamanhos de arquivo menores e maior compatibilidade",
    "convert.png.ico":
      "Converta PNG para ICO para favicon de site e ícones de aplicativos",
    "convert.png.bmp":
      "Converta PNG para BMP para compatibilidade com aplicativos Windows mais antigos",
    "convert.png.apng":
      "Converta PNG para APNG para adicionar capacidades de animação",

    "convert.ico.webp":
      "Converta ICO para WebP para uso moderno na web com melhor compressão",
    "convert.ico.jpeg":
      "Converta ICO para JPEG para melhor compatibilidade com editores de fotos",
    "convert.ico.jpg":
      "Converta ICO para JPG para melhor compatibilidade com todos os dispositivos e aplicativos",
    "convert.ico.png":
      "Converta ICO para PNG para melhor qualidade e formato moderno",
    "convert.ico.bmp":
      "Converta ICO para BMP para compatibilidade com aplicativos Windows mais antigos",
    "convert.ico.apng":
      "Converta ICO para APNG para adicionar animação a ícones",

    "convert.bmp.webp":
      "Converta BMP para WebP para tamanhos de arquivo muito menores e melhor desempenho na web",
    "convert.bmp.jpeg":
      "Converta BMP para JPEG para tamanhos de arquivo menores e melhor compatibilidade",
    "convert.bmp.jpg":
      "Converta BMP para JPG para tamanhos de arquivo menores e maior compatibilidade",
    "convert.bmp.png":
      "Converta BMP para PNG para compressão sem perdas e suporte a transparência",
    "convert.bmp.ico":
      "Converta BMP para ICO para uso como favicons e ícones de aplicativos",
    "convert.bmp.apng":
      "Converta BMP para APNG para adicionar capacidades de animação",

    "convert.apng.webp":
      "Converta APNG para WebP para melhor compressão mantendo a animação",
    "convert.apng.jpeg":
      "Converta APNG para JPEG (nota: animação e transparência serão perdidas)",
    "convert.apng.jpg":
      "Converta APNG para JPG (nota: animação e transparência serão perdidas)",
    "convert.apng.png":
      "Converta APNG para PNG (nota: a animação será perdida, mas a transparência será mantida)",
    "convert.apng.ico":
      "Converta APNG para ICO para uso como favicons (a animação será perdida)",
    "convert.apng.bmp":
      "Converta APNG para BMP (animação e transparência serão perdidas)",

    // About Page
    "about.title": "Sobre Nós",
    "about.welcome":
      "Bem-vindo ao Conversor de Imagens, sua ferramenta para todas as necessidades de conversão de imagens. Construímos esta plataforma para fornecer uma solução simples, mas poderosa para converter imagens entre vários formatos.",
    "about.mission.title": "Nossa Missão",
    "about.mission.content":
      "Nossa missão é tornar a conversão de imagens acessível a todos. Seja você um designer profissional, desenvolvedor ou apenas alguém que precisa converter uma imagem ocasionalmente, temos você coberto. Nos esforçamos para fornecer um serviço amigável que oferece conversões de imagens de alta qualidade sem a necessidade de software especializado ou conhecimento técnico.",
    "about.why.title": "Por que nos escolher?",
    "about.fast.title": "Conversão Rápida",
    "about.fast.content":
      "Nosso motor de conversão é otimizado para velocidade, permitindo que você converta suas imagens em segundos.",
    "about.privacy.title": "Privacidade em Primeiro Lugar",
    "about.privacy.content":
      "Sua privacidade é importante para nós. Todo o processamento de imagem acontece em seu navegador, e não armazenamos suas imagens em nossos servidores.",
    "about.noinstall.title": "Sem Necessidade de Instalação",
    "about.noinstall.content":
      "Acesse nossa ferramenta de qualquer dispositivo com um navegador web. Sem necessidade de instalar software adicional.",
    "about.userfriendly.title": "Amigável ao Usuário",
    "about.userfriendly.content":
      "Projetamos nossa interface para ser intuitiva e fácil de usar para todos, independentemente da experiência técnica.",
    "about.team.title": "Nossa Equipe",
    "about.team.content":
      "Somos uma pequena equipe de desenvolvedores e designers apaixonados que acreditam em criar ferramentas que tornam a vida das pessoas mais fácil. Nossas diversas origens em desenvolvimento web, design UI/UX e processamento de imagens nos permitiram criar uma ferramenta que combina excelência técnica com facilidade de uso.",
    "about.team.lead": "Desenvolvedor Líder",
    "about.team.designer": "Designer UI/UX",
    "about.team.expert": "Especialista em Processamento de Imagens",
    "about.philosophy.title": "Nossa Filosofia",
    "about.philosophy.content1":
      "Simplificamos o processamento e conversão de imagens online, fornecendo uma solução rápida e fácil. Nossa plataforma foi criada para eliminar a necessidade de baixar software, que é um incômodo comum para a maioria dos usuários que lidam com imagens.",
    "about.philosophy.content2":
      "Integramos todas as funcionalidades essenciais necessárias para processar imagens, seja para uso pessoal ou comercial, em um local conveniente.",
    "about.philosophy.content3":
      "Por que oferecemos essas ferramentas de edição de imagem gratuitamente? Acreditamos na democratização do acesso a ferramentas de edição de imagem de alta qualidade. Todos merecem uma solução sem custo sem comprometer a qualidade.",

    // Privacy Page
    "privacy.title": "Política de Privacidade",
    "privacy.intro":
      "No Conversor de Imagens, picmodifier.com valoriza sua privacidade e está comprometido em proteger suas informações pessoais. Esta Política de Privacidade explica como picmodifier.com lida com seus dados quando você usa o serviço picmodifier.com. picmodifier.com quer enfatizar que picmodifier.com não coleta ou armazena nenhuma informação pessoal do cliente.",
    "privacy.info.title": "1. Informações que picmodifier.com Processa",
    "privacy.info.image.title": "1.1 Dados de Imagem:",
    "privacy.info.image.content":
      "Quando você usa o serviço de conversão de imagem picmodifier.com, suas imagens são processadas inteiramente em seu navegador. picmodifier.com não armazena suas imagens em nossos servidores, e elas são automaticamente excluídas após o processamento.",
    "privacy.info.personal.title": "1.2 Sem Coleta de Informações Pessoais:",
    "privacy.info.personal.content":
      "picmodifier.com não coleta nenhuma informação pessoal de nossos usuários. Você pode usar nosso serviço sem fornecer nenhum detalhe pessoal.",
    "privacy.info.usage.title": "1.3 Dados de Uso Anônimos:",
    "privacy.info.usage.content":
      "picmodifier.com coleta apenas dados de uso anônimos, como tipo de navegador, páginas de referência/saída e carimbos de data/hora. Esta informação é usada exclusivamente para melhorar nosso serviço e experiência do usuário. Nenhum identificador pessoal é coletado ou armazenado.",
    "privacy.info.cookies.title": "1.4 Cookies:",
    "privacy.info.cookies.content":
      "picmodifier.com usa cookies mínimos para melhorar sua experiência em nosso site. Estes cookies não rastreiam informações pessoais. Você pode configurar seu navegador para recusar todos ou alguns cookies do navegador, mas isso pode afetar a funcionalidade.",
    "privacy.use.title": "2. Como picmodifier.com Usa Informações",
    "privacy.use.service.title": "2.1 Provisão de Serviço:",
    "privacy.use.service.content":
      "picmodifier.com usa as informações exclusivamente para fornecer e manter nosso serviço, incluindo a realização de conversões de imagem conforme solicitado. Todo o processamento é feito localmente em seu navegador.",
    "privacy.use.improve.title": "2.2 Melhoria do Serviço:",
    "privacy.use.improve.content":
      "picmodifier.com analisa padrões de uso anônimos para melhorar nosso site, produtos e serviços. Esta análise não envolve nenhuma informação pessoal.",
    "privacy.use.communications.title": "2.3 Comunicações:",
    "privacy.use.communications.content":
      "Se você optar por entrar em contato conosco, picmodifier.com usará suas informações de contato fornecidas apenas para responder à sua consulta específica. picmodifier.com não armazena essas informações para fins de marketing.",
    "privacy.security.title": "3. Segurança de Dados",
    "privacy.security.content":
      "picmodifier.com implementa medidas de segurança apropriadas para proteger suas informações pessoais. No entanto, nenhum método de transmissão pela Internet ou armazenamento eletrônico é 100% seguro. Embora picmodifier.com se esforce para usar meios comercialmente aceitáveis para proteger seus dados, não podemos garantir sua segurança absoluta.",
    "privacy.thirdparty.title": "4. Serviços de Terceiros",
    "privacy.thirdparty.content":
      "O serviço picmodifier.com pode conter links para sites ou serviços de terceiros que não são de propriedade ou controlados por picmodifier.com. picmodifier.com não tem controle e não assume responsabilidade pelo conteúdo, políticas de privacidade ou práticas de quaisquer sites ou serviços de terceiros.",
    "privacy.children.title": "5. Privacidade das Crianças",
    "privacy.children.content":
      "O serviço picmodifier.com não é destinado para uso por crianças menores de 13 anos. picmodifier.com não coleta conscientemente informações pessoalmente identificáveis de crianças menores de 13 anos. Se você é pai ou responsável e acredita que seu filho forneceu picmodifier.com com informações pessoais, entre em contato conosco imediatamente.",
    "privacy.changes.title": "6. Alterações nesta Política de Privacidade",
    "privacy.changes.content":
      "picmodifier.com pode atualizar nossa Política de Privacidade de tempos em tempos. picmodifier.com notificará você sobre quaisquer alterações publicando a nova Política de Privacidade nesta página. Você é aconselhado a revisar esta Política de Privacidade periodicamente para quaisquer alterações.",
    "privacy.contact.title": "7. Entre em Contato com picmodifier.com",
    "privacy.contact.content":
      "Se você tiver alguma dúvida sobre esta Política de Privacidade, entre em contato com picmodifier.com em picmodifier@outlook.com.",
    "privacy.last.updated": "Última atualização: {date}",

    // Terms Page
    "terms.title": "Termos de Serviço",
    "terms.welcome":
      "Bem-vindo ao picmodifier.com. Ao acessar ou usar o serviço picmodifier.com, você concorda em estar vinculado a estes Termos de Serviço. Por favor, leia estes termos cuidadosamente antes de usar o serviço picmodifier.com.",
    "terms.acceptance.title": "1. Aceitação dos Termos",
    "terms.acceptance.content":
      "Ao acessar ou usar o serviço picmodifier.com, você concorda em estar vinculado a estes Termos de Serviço e todas as leis e regulamentos aplicáveis. Se você não concordar com qualquer um destes termos, você está proibido de usar ou acessar o serviço picmodifier.com.",
    "terms.license.title": "2. Licença de Uso",
    "terms.license.permission.title": "2.1 Permissão:",
    "terms.license.permission.content":
      "picmodifier.com concede a você uma licença limitada, não exclusiva e não transferível para usar nosso serviço para fins pessoais e não comerciais.",
    "terms.license.restrictions.title": "2.2 Restrições:",
    "terms.license.restrictions.content": "Você não pode:",
    "terms.license.restrictions.list":
      '• Modificar ou copiar os materiais\n• Usar os materiais para qualquer finalidade comercial\n• Tentar descompilar ou fazer engenharia reversa de qualquer software contido no serviço picmodifier.com\n• Remover quaisquer direitos autorais ou outras notações proprietárias dos materiais\n• Transferir os materiais para outra pessoa ou "espelhar" os materiais em qualquer outro servidor',
    "terms.content.title": "3. Conteúdo do Usuário",
    "terms.content.ownership.title": "3.1 Propriedade:",
    "terms.content.ownership.content":
      "Você mantém todos os direitos sobre seu conteúdo. Ao usar o serviço picmodifier.com, você concede a picmodifier.com uma licença limitada para processar seu conteúdo exclusivamente para o propósito de fornecer o serviço.",
    "terms.content.prohibited.title": "3.2 Conteúdo Proibido:",
    "terms.content.prohibited.content":
      "Você concorda em não enviar, processar ou compartilhar qualquer conteúdo que:",
    "terms.content.prohibited.list":
      "• Viola quaisquer leis ou regulamentos\n• Infringe direitos de propriedade intelectual\n• Contém código prejudicial ou malicioso\n• É inapropriado, ofensivo ou viola quaisquer direitos de terceiros",
    "terms.disclaimer.title": "4. Isenção de Responsabilidade",
    "terms.disclaimer.content":
      'O serviço picmodifier.com é fornecido "como está". picmodifier.com não faz garantias, expressas ou implícitas, e por este meio renuncia e nega todas as outras garantias, incluindo, sem limitação, garantias implícitas ou condições de comercialização, adequação a um propósito específico, ou não violação de propriedade intelectual ou outra violação de direitos.',
    "terms.limitations.title": "5. Limitações",
    "terms.limitations.content":
      "Em nenhum caso picmodifier.com ou nossos fornecedores serão responsáveis por quaisquer danos (incluindo, sem limitação, danos por perda de dados ou lucro, ou devido a interrupção de negócios) decorrentes do uso ou incapacidade de usar o serviço picmodifier.com.",
    "terms.accuracy.title": "6. Precisão dos Materiais",
    "terms.accuracy.content":
      "Os materiais que aparecem no serviço picmodifier.com podem incluir erros técnicos, tipográficos ou fotográficos. picmodifier.com não garante que qualquer um dos materiais em nosso serviço seja preciso, completo ou atual. picmodifier.com pode fazer alterações nos materiais contidos em nosso serviço a qualquer momento sem aviso prévio.",
    "terms.links.title": "7. Links",
    "terms.links.content":
      "picmodifier.com não revisou todos os sites vinculados ao serviço picmodifier.com e não é responsável pelo conteúdo de qualquer site vinculado. A inclusão de qualquer link não implica endosso por picmodifier.com do site. O uso de qualquer site vinculado é por conta e risco do usuário.",
    "terms.modifications.title": "8. Modificações",
    "terms.modifications.content":
      "picmodifier.com pode revisar estes termos de serviço a qualquer momento sem aviso prévio. Ao usar o serviço picmodifier.com, você está concordando em estar vinculado à versão então atual destes termos de serviço.",
    "terms.governing.title": "9. Lei Aplicável",
    "terms.governing.content":
      "Estes termos e condições são regidos e interpretados de acordo com as leis e você se submete irrevogavelmente à jurisdição exclusiva dos tribunais naquele local.",
    "terms.contact.title": "10. Entre em Contato com picmodifier.com",
    "terms.contact.content":
      "Se você tiver alguma dúvida sobre estes Termos de Serviço, entre em contato com picmodifier.com em picmodifier@outlook.com.",
    "terms.last.updated": "Última atualização: {date}",
  },
};
